/**
 * `Card`'s own radius (`rounded-lg`) and border color (`border-border`) are
 * one step rounder — and under the Cofactor brand, a different hairline —
 * than the filter-bar/sparkline/table lockup elsewhere on this page, which
 * are `rounded-md` and opt into `filter-lockup-table`'s `--line-2` override
 * (`packages/ui/src/styles/cofactor/forms-dialogs.css`). Reusing that same
 * class (rather than hardcoding `--line-2` in each consumer) keeps the color
 * override to one source of truth. Canary is unaffected — the class carries
 * no rule outside `.cofactor`.
 *
 * Used by any surface that must match the `filter-lockup-table` hairline
 * rather than `Card`'s own: the `LiveRunCard` and `UpcomingScheduledRuns` rail
 * cards, and `RunTriageLockup` on the run-detail page (which sits directly
 * above `AgenticRunFailuresTable`, itself a `filter-lockup-table` consumer).
 *
 * @module ui/pages/runs/test-runs/matchLockupBorder
 */
export const MATCH_LOCKUP_BORDER = 'rounded-md filter-lockup-table';
